var $ = require('jQuery');

/**
 * Revealer helper.
 *
 * Shows and hides a block of content.
 * Currently used to reveal bulk tagging form on entry management page.
 */
module.exports = function() {

    this.toggle = function (form) {
        var button = form.find('.marker-action-button');
        var target = $(button.data('target'));
        var container = target.parent();
        var openLabel = button.data('open');
        var closeLabel = button.data('close');

        if (container.hasClass('hidden')) {
            container.removeClass('hidden');
            button.text(closeLabel);
        } else {
            container.addClass('hidden');
            button.text(openLabel);
        }
    };

    this.hide = function (form) {
        var button = form.find('.marker-action-button');
        var container = $(button.data('target')).parent();

        if (!container.hasClass('hidden')) {
            container.addClass('hidden');
            button.text(button.data('open'));
        }
    };

};
